import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import { Headers, Http, RequestOptionsArgs } from '@angular/http';
import { AuthenticationService } from 'app/core/index';
import { URLSearchParams } from '@angular/http';
import { map } from 'rxjs/operators';

@Injectable()
export class AffiliateService {
  constructor(private http: Http, private auth: AuthenticationService) {}

  public getCampaigns() {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http
      .get('/api/affiliate', {
        headers: headers,
      })
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public createCampaign(name: string, code: string) {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http
      .post(
        '/api/affiliate',
        {
          name,
          code,
        },
        {
          headers: headers,
        }
      )
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public getCampaign(code: string) {
    return this.http.get('/api/affiliate/code/' + code);
  }

  public getRegistrations(campaignId: string, page: any) {
    const params: URLSearchParams = new URLSearchParams();
    params.append('id', campaignId);
    params.append('page', page);

    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http
      .get(`/api/affiliate/${campaignId}/registrations`, { headers: headers, search: params })
      .toPromise()
      .then(data => {
        return data.json();
      });
  }

  public claim(campaignId: string) {
    const headers: Headers = new Headers();
    headers.append('Authorization', this.auth.credentials.accessToken);

    return this.http.post(`/api/affiliate/${campaignId}/claim`, {}, { headers }).pipe(map(response => response.json()));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/affiliate.service.ts